import {
  AfterViewInit,
  Component,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import {language} from '../../../language/vn';

@Component({
  selector: 'egov-message',
  templateUrl: './message.component.html',
  encapsulation: ViewEncapsulation.None
})
export class EgovMessageComponent implements OnInit, AfterViewInit {
  public totalVanBanDen: number =100;
  public totalChuaXuLy: number = 20;
  public totalDangXuLy: number = 10;
  public totalHoanThanh: number=70;
  public totalPhoCap: number =30;
  public totalChoGiaoXuLy: number=20;

  public language = language;
  constructor(
  ) {
  }
  ngAfterViewInit() {

  }
  ngOnInit(): void {

  }


}

